/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import _ from 'lodash'
import DetailView from '../../../dpe-usco/components/Details/DetailView'
import DetailCardWithTable from '../../../dpe-usco/components/Details/DetailCardWithTable'
import Select from '../../../dpe-usco/components/Select/Select'
import SearchBox from '../../../components/subComponents/SearchBox'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'
import ScaleTicketDetailModal from '../../../views/ContractDashboard/ScaleTicketDetailModal'
import { yearsOptionFactory, customSort } from '../../../services/utils'
import SingleTicketUpload from '../../DetailViews/Company/SingleTicketUpload'
import { getProductionPlan, getScaleTickets, deleteScaleTicket, getCompany, getSalesYear } from '../../../services/apiHelper'
import HeaderFilter from '../../../components/subComponents/HeaderFilter'

const SELECT_CUSTOM_CLASS_NAMES = {
  buttonClassNames:
    'bgc-white bd2-s-input bdrs-4 h38 mt-1 df aic jcsb pl10 pt5 pb5 pr5'
}
const MAX_YEARS = 0 // max years to go above for years dropdown.
const MIN_YEARS = -4 // min years to go below for years dropdown. Example 2020 => 2019

function usePrevious(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

const ScaleTicketsDetailView = () => {
  const { scale_year, company_id } = useParams()
  const [scaleTicketsYear, setScaleTicketsYear] = useState(scale_year)
  const [allTickets, setAllTickets] = useState([])
  const [filterScaleTickets, setFilterScaleTickets] = useState([])
  const [scaleTicketsLimit, setScaleTicketsLimit] = useState(15)
  const [lastCursor, setLastCursor] = useState(null)
  const [hasMore, setHasMore] = useState(true)
  const [isLoadingMore, setIsLoadingMore] = useState(false)
  const [prodPlanId, setProdPlanId] = useState()
  const [scaleTicketsStatus, setScaleTicketsStatus] = useState('LOADING')
  const [searchTerm, setSearchTerm] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const [intialRender, setIntialRender] = useState(true)
  const [companyName , setcompanyName] = useState('')
  const [showModal, setShowModal] = useState(false)
  const prev = usePrevious({ scaleTicketsYear })
  const [fetchScaleTickets, setFetchScaleTickets] = useState(false)
  const [editScaleId, setEditScaleId] = useState('')
  const [editData, setEditData] = useState(null)
  const status = 'EMPTY'
  const dataKeys = [
    'grower_name',
    'original_new_contract_id',
    'scale_ticket_id',
    'scale_ticket_date',
    'gross_quantity',
    'net_quantity',
    'test_weight',
    'moisture',
    'damage',
    'foreign_material',
    'rapid_visco_analyzer'
  ]

  const [defaultContractYear, setDefaultContractYear] = useState(
    new Date().getFullYear().toString()
  )
  useEffect(() => {
    const init = async () => {
      await getSalesYear().then(sales_year => {
        setDefaultContractYear(sales_year.data.sales_year)
      })
    }
    if (scale_year) {
      init()
    }
  }, [scale_year])

  const yearsOptions = yearsOptionFactory(parseInt(defaultContractYear), MIN_YEARS, MAX_YEARS)

  const headerCellSort = (value, dataKey) => {
    let headClass = 'cell df aic'
    if(value==='Grower')
      headClass = 'df aic flx2 mr1%'

    const acendCallBack = () => {
      setFilterScaleTickets(customSort(filterScaleTickets, dataKey, 'asc'))
    }

    const decendCallBack = () => {
      setFilterScaleTickets(customSort(filterScaleTickets, dataKey, 'desc'))
    }

    return (
      <div key={value} className={headClass}>
        <span>{value}</span>
        <HeaderFilter
          dataKey={dataKey}
          descend={() => decendCallBack()}
          ascend={() => acendCallBack()}
        />
      </div>
    )
  }

  const headerCell = value => {
    let headClass = 'cell df aic'
    if(value==='Grower')
      headClass = 'df aic flx2 mr1%'
    return (
      <div key={value} className={headClass}>
        <span>{value}</span>
      </div>
    )
  }

  const convertDateFromISO = date => {
    if (typeof date === 'string') {
      let returnDate = date && date.split('T')[0].split('-').reverse()
      returnDate = returnDate[1]+'/'+returnDate[0]+'/'+returnDate[2]
      return returnDate
    }
  }

  const editScaleTicketHandler = (scale_ticket_id, data) =>{
    setEditScaleId(scale_ticket_id)
    setEditData(data)
    setShowModal(true)
  }

  useEffect(() => {
    if(!showModal) {
      setEditScaleId('')
    }
  },[showModal])

  const [allSelectedRows, setAllSelectedRows] = useState([])
  const structure = {
    headers: [
      {
        value: '',
        format() {
          return <div className="cell df aic" style={{ width: 28 }} />
        }
      },
      {
        value: 'Grower',
        format() {
          return headerCellSort(this.value, 'grower_name')
        }
      },
      {
        value: 'Contract Id',
        format() {
          return headerCellSort(this.value, 'original_new_contract_id')
        }
      },
      {
        value: 'Ticket #',
        format() {
          return headerCell(this.value)
        }
      },
      {
        value: 'Ticket Date',
        format() {
          return headerCellSort(this.value, 'scale_ticket_date')
        }
      },
      {
        value: 'Gross Qty',
        format() {
          return headerCell(this.value)
        }
      },
      {
        value: 'Net Qty',
        format: () => {
          return headerCellSort('Net Qty', 'net_quantity')
        }
      },
      {
        value: 'Test Wt',
        format() {
          return headerCell(this.value)
        }
      },
      {
        value: 'MST',
        format() {
          return headerCell(this.value)
        }
      },
      {
        value: 'DMG',
        format() {
          return headerCell(this.value)
        }
      },
      {
        value: 'FM',
        format() {
          return headerCell(this.value)
        }
      },
      {
        value: 'RVA',
        format: () => {
          return headerCell('RVA')
        }
      }
    ],
    dataKeys: [
      'scale_ticket_id',
      'grower_name',
      'original_new_contract_id',
      'scale_ticket_number',
      'scale_ticket_date',
      'gross_quantity',
      'net_quantity',
      'test_weight',
      'moisture',
      'damage',
      'foreign_material',
      'rapid_visco_analyzer'
    ],
    rowFormat: {
      grower_name: {
        format: grower_name => {
          return grower_name
        },
        overwriteStyles:true,
        customStyle:'df aic flx2 mr1%'
      },
      scale_ticket_number: {
        format: scale_ticket_number => {
          return  scale_ticket_number || '-'
        }
      },
      scale_ticket_id: {
        format: ticket_id => {
          const ticketData = filterScaleTickets.filter(function (ticket) {
            return ticket.scale_ticket_id === ticket_id
          })[0]
          return <ScaleTicketDetailModal data={ticketData} editScaleTicketHandler={editScaleTicketHandler} handleDelete={handleDelete} onDelete={deleteScaleTicket} productionPlanId={prodPlanId}/>
        }
      },
      scale_ticket_date: {
        format: ticket_date => {
          return convertDateFromISO(ticket_date)
        }
      },
      gross_quantity: {
        format: gross_quantity => {
          if (!gross_quantity || String(gross_quantity).trim() === '') {
            return '-'
          }
          return parseFloat(gross_quantity?.replace(/,/g, '')).toFixed(2)
        }
      },
      net_quantity: {
        format: net_quantity => {
          return parseFloat(net_quantity?.replace(/,/g, '')).toFixed(2)
        }
      },
      test_weight: {
        format: test_weight => {
          return test_weight
        }
      },
      moisture: {
        format: moisture => {
          return moisture
        }
      },
      damage: {
        format: damage => {
          return damage
        }
      },
      foreign_material: {
        format: foreign_material => {
          return foreign_material
        }
      },
      rapid_visco_analyzer: {
        format: rapid_visco_analyzer => {
          return rapid_visco_analyzer
        }
      }
    },
    setAllSelectedRowsFunc: setAllSelectedRows
  }

  useEffect(() => {
    getCompany(company_id).then(obj => {
      setcompanyName(obj.company_name)
    })
  })

  useEffect( () => {
    const setProductionPlan = async () => {
      await getProductionPlan(company_id, 'company_id').then(
        async prodPlans => {
          //setcompanyName(prodPlans[0].company_name)
          const planData = prodPlans.map(plan => {
            return {
              production_plan_id: plan.production_plan_id,
              contractYear: plan.contract_year
            }
          })
          let productionPlan = planData.filter(function (plan) {
            return plan.contractYear.toString() === scaleTicketsYear
          })
          if(productionPlan.length > 0){
            setIntialRender(false)
            setProdPlanId(productionPlan[0].production_plan_id)
          }
          else {
            setIsLoading(false)
            setScaleTicketsStatus('EMPTY')
            setIntialRender(false)
            setProdPlanId()
          }
        }
      )
    }
    if(prev?.scaleTicketsYear !== scaleTicketsYear) {
      setIsLoading(true)
      setProductionPlan()
      setAllSelectedRows([])
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scaleTicketsYear])

  const PAGE_SIZE = 100

  const applySearchFilter = useCallback(tickets => {
    if (searchTerm === '') return tickets
    return tickets.filter(row => {
      let hasSearchTerm = false
      dataKeys.forEach(key => {
        let testable =
          typeof row[key] === 'object'
            ? row[key]?.grower_name.toLowerCase()
            : row[key] ? row[key].toString().toLowerCase() : null
        if (_.includes(testable, searchTerm.toLowerCase())) {
          hasSearchTerm = true
        }
      })
      return hasSearchTerm
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm])

  // Reactive filter: re-apply whenever search term or source list changes
  useEffect(() => {
    setFilterScaleTickets(applySearchFilter(allTickets))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm, allTickets])

  useEffect(() => {
    const setScaleTickets = async () => {
      setIsLoadingMore(false)
      setAllTickets([])
      let lastCursorLocal = null

      const firstPage = await getScaleTickets(prodPlanId, null, PAGE_SIZE)
      if (!firstPage.length) {
        setIsLoading(false)
        setScaleTicketsStatus('EMPTY')
        return
      }

      const firstFiltered = firstPage.filter(ticket => !ticket.scale_ticket_id.includes('zeroout'))
      setIsLoading(false)
      setScaleTicketsStatus()
      setAllTickets(firstFiltered)

      if (firstPage.length < PAGE_SIZE) return

      lastCursorLocal = { lastScaleTicketId: firstPage[firstPage.length - 1].scale_ticket_id, lastProductionPlanId: prodPlanId }
      setIsLoadingMore(true)

      while (lastCursorLocal) {
        const page = await getScaleTickets(
          prodPlanId,
          null,
          PAGE_SIZE,
          lastCursorLocal.lastScaleTicketId,
          lastCursorLocal.lastProductionPlanId
        )
        if (!page.length) break
        const filtered = page.filter(ticket => !ticket.scale_ticket_id.includes('zeroout'))
        setAllTickets(prev => [...prev, ...filtered])
        if (page.length < PAGE_SIZE) break
        lastCursorLocal = { lastScaleTicketId: page[page.length - 1].scale_ticket_id, lastProductionPlanId: prodPlanId }
      }

      setIsLoadingMore(false)
    }
    if (prodPlanId) {
      setScaleTickets()
    } else {
      if (!intialRender) setIsLoading(false)
      setScaleTicketsStatus('EMPTY')
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prodPlanId, fetchScaleTickets])

  const getMoreScaleTickets = () => {}

  const handleDelete = async () => {
    if (allSelectedRows?.length) {
      window.location.reload()
      return
    }
    const scaleTickets = await getScaleTickets(prodPlanId, null, PAGE_SIZE)
    if (scaleTickets?.length) {
      setScaleTicketsStatus()
      const filterOutZeroOut = scaleTickets.filter(ticket => !ticket.scale_ticket_id.includes('zeroout'))
      setFilterScaleTickets(filterOutZeroOut)
      if (scaleTickets.length === PAGE_SIZE) {
        const last = scaleTickets[scaleTickets.length - 1]
        setLastCursor({ lastScaleTicketId: last.scale_ticket_id, lastProductionPlanId: prodPlanId })
        setHasMore(true)
      } else {
        setLastCursor(null)
        setHasMore(false)
      }
    } else {
      setScaleTicketsStatus('EMPTY')
      setHasMore(false)
    }
  }

  const renderButtonRow = () => {
    return (
      <div className="df jcsb">
        <div className="mr10">
          <SearchBox
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            placeholder="Search"
          />
        </div>
        <div>
          <Select
            customClassName={SELECT_CUSTOM_CLASS_NAMES}
            handleSelection={year => setScaleTicketsYear(year.value)}
            defaultValue={scaleTicketsYear}
            options={yearsOptions}
          />
        </div>
      </div>
    )
  }
  return (
    <>
      {showModal &&
        <SingleTicketUpload fetchScaleTickets={fetchScaleTickets} setFetchScaleTickets={setFetchScaleTickets} scaleTicketsYear={scaleTicketsYear} prodPlanID={prodPlanId} setShowModal={setShowModal} showModal={showModal} editScaleId={editScaleId} editData={editData}></SingleTicketUpload>
      }
      <DetailView title={companyName}>
        {isLoading ?
          <div className='h100% w100% df aic jcc mt40'>
            <div className='loader h80 w80'/> 
          </div> :
          <div className='scale-ticket-detail'>
            <DetailCardWithTable
              button={renderButtonRow()}
              title="Scale Tickets"
              structure={structure}
              data={filterScaleTickets}
              statusComponent={
                scaleTicketsStatus ? (
                  <TableStatus
                    status={status}
                    prompt={'No scale tickets for this sales year'}
                  />
                ) : null
              }
              totalSelectedRow={allSelectedRows}
              onScrollAPI={getMoreScaleTickets}
              deleteMultipleScaleTickets={true}
              productionPlanId={prodPlanId}
            />
            {isLoadingMore &&
              <div>
                <div className='df aic fz13 c-gray'>
                  <span>Loading more tickets...</span>
                </div>
                <div className='bar-loader' />
              </div>
            }
          </div>
        }
      </DetailView>
    </>
  )
}

export default ScaleTicketsDetailView